import Vue from 'vue'
import VueRouter from 'vue-router'

import LoginView from '../views/LoginView.vue'
import IndexView from '../views/Back/IndexView.vue'
import MainView from '../views/Back/MainView.vue'

import AdminListView from '../views/Back/Admin/AdminListView.vue'
import StudentListView from '../views/Back/Student/StudentListView.vue'
import ReferenceListView from '../views/Back/Reference/ReferenceListView.vue'

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// 重写push方法
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch(err => err);
};

// 重写replace方法
VueRouter.prototype.replace = function(location) {
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(VueRouter)

const routes = [
  {
    path: '/Login',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/',
    name: 'IndexView',
    component: IndexView,
    children: [
      {
        path: '/Main',
        name: 'MainView',
        component: MainView
      },
      {
        path: '/Admin/List',
        name: 'AdminListView',
        component: AdminListView
      },
      {
        path: '/Student/List',
        name: 'StudentListView',
        component: StudentListView
      },
      {
        path: '/Reference/List',
        name: 'ReferenceListView',
        component: ReferenceListView
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
